import useIsMobile from '../../../hooks/useIsMobile';
import FJModal from '../FJModal';
import FJServerBusyModal from './FJServerBusyModal';
import { useDispatch, useSelector } from 'react-redux';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJUtil from '../../../util/FJUtil';

const FJServerBusyModalContainer = () => {
    const dispatch = useDispatch();
    const isMobile = useIsMobile();
    const { display } = useSelector(state => state.modals.serverBusyModalData);

    const _onClose = () => {
        dispatch(FJActionModal.hideServerBusyModalAction());
    };

    const _onUpgrade = () => {
        dispatch(FJActionModal.hideServerBusyModalAction());
        FJUtil.getCredits();
    };

    return (
        <FJModal visible={display} borderRadius={isMobile ? 20 : 10}>
            <FJServerBusyModal onClose={_onClose} isMobile={isMobile} onUpgrade={_onUpgrade} />
        </FJModal>
    );
};

export default FJServerBusyModalContainer;
